export const SAVE_AUTHENTICATION = 'geoface/fields/SAVE_AUTHENTICATION';
export const LOAD_ERROR = 'geoface/fields/LOAD_ERROR';

export const LOAD_USER_FIELDS = 'geoface/fields/LOAD_USER_FIELDS';
export const LOAD_FIELD_DETAILS = 'geoface/fields/LOAD_FIELD_DETAILS';
export const LOAD_USER_FIELDS_SUCCESS = 'geoface/fields/LOAD_USER_FIELDS_SUCCESS';
export const UPDATE_USER_FIELDS = 'geoface/fields/UPDATE_USER_FIELDS';

export const SET_SOIL_ANALYSIS = 'geoface/fields/SET_SOIL_ANALYSIS';
export const LOAD_ALL_FIELDS = 'geoface/fields/LOAD_ALL_FIELDS';
export const LOAD_ALL_FIELDS_LOADING = 'geoface/fields/LOAD_ALL_FIELDS_LOADING';
export const LOAD_ALL_FIELDS_SUCCESS = 'geoface/fields/LOAD_ALL_FIELDS_SUCCESS';
export const SHOW_ALL_FIELDS = 'geoface/fields/SHOW_ALL_FIELDS';
export const SHOW_SETTINGS = 'geoface/fields/SHOW_SETTINGS';
export const SHOW_SPRAYING = 'geoface/fields/SHOW_SPRAYING';
export const SHOW_FARM_FINANCE = 'geoface/fields/SHOW_FARM_FINANCE';

export const ADD_POLYGON = 'geoface/fields/ADD_POLYGON';

export const ADD_POLYGONS = 'geoface/fields/ADD_POLYGONS';
export const REMOVE_POLYGON = 'geoface/fields/REMOVE_POLYGON';
export const UPDATE_POLYGON = 'geoface/fields/UPDATE_POLYGON';
export const EDIT_POLYGON = 'geoface/fields/EDIT_POLYGON';
export const EDIT_FIELD_INFORMATION = 'geoface/fields/EDIT_FIELD_INFORMATION';
export const CLEAR_POLYGONS = 'geoface/fields/CLEAR_POLYGONS';

export const CHANGE_MODE = 'geoface/fields/CHANGE_MODE';
export const EDIT_FIELD = 'geoface/fields/EDIT_FIELD';
export const SELECT_FIELD = 'geoface/fields/SELECT_FIELD';
export const TOGGLE_PROBLEMS = 'geoface/fields/TOGGLE_PROBLEMS';
export const SHOW_SCOUTING_DATA = 'geoface/fields/SHOW_SCOUTING_DATA';
export const REFRESH_SCOUTING_DATA = 'geoface/fields/REFRESH_SCOUTING_DATA';
export const LOAD_SCOUTING_LIST = 'geoface/fields/LOAD_SCOUTING_LIST';

export const SAVE_MAP_CENTER = 'geoface/fields/SAVE_MAP_CENTER';
export const SAVE_MAP_DATA = 'geoface/fields/SAVE_MAP_DATA';
export const SAVE_MAP = 'geoface/fields/SAVE_MAP';

export const LOAD_NDVI_LIST = 'geoface/fields/LOAD_NDVI_LIST';
export const LOAD_NDVI_LIST_SUCCESS = 'geoface/fields/LOAD_NDVI_LIST_SUCCESS';

export const LOAD_NDVI = 'geoface/fields/LOAD_NDVI';
export const LOAD_NDVI_SUCCESS = 'geoface/fields/LOAD_NDVI_SUCCESS';
export const LOAD_NDVI_DETAILS_SUCCESS = 'geoface/fields/LOAD_NDVI_DETAILS_SUCCESS';
export const LOAD_NDVI_EXPENSES_SUCCESS = 'geoface/fields/LOAD_NDVI_EXPENSES_SUCCESS';

export const LOAD_RECLAMATION = 'geoface/fields/LOAD_RECLAMATION';
export const SAVE_RECLAMATION_DATA = 'geoface/fields/SAVE_RECLAMATION_DATA';
export const LOAD_RECLAMATION_SUCCESS = 'geoface/fields/LOAD_RECLAMATION_SUCCESS';

export const LOAD_FERTILIZATION = 'geoface/fields/LOAD_FERTILIZATION';
export const LOAD_FERTILIZATION_SUCCESS = 'geoface/fields/LOAD_FERTILIZATION_SUCCESS';
export const RESET_FERTILIZATION = 'geoface/fields/RESET_FERTILIZATION';
export const SAVE_NITROGEN_CONTENT = 'geoface/fields/SAVE_NITROGEN_CONTENT';

export const FIELD_FILTER = 'geoface/fields/FIELD_FILTER';
export const FIELD_ID_FILTER = 'geoface/fields/FIELD_ID_FILTER';
export const SELECT_FIELD_TO_MERGE = 'geoface/fields/SELECT_FIELD_TO_MERGE';

export const LOAD_CROPS_SUCCESS = 'geoface/fields/LOAD_CROPS_SUCCESS';
export const LOAD_CROPS = 'geoface/fields/LOAD_CROPS';
export const UPDATE_FIELD_GROUPS = 'geoface/fields/UPDATE_FIELD_GROUPS';
export const HIDE_INFO_PANEL = 'geoface/fields/HIDE_INFO_PANEL';
export const TOGGLE_SIMPLE_ACTION_MODAL = 'geoface/TOGGLE_SIMPLE_ACTION_MODAL';
export const USER_LOGOUT = 'geoface/USER_LOGOUT';
export const TOGGLE_NOTIFICATION_MODAL = 'geoface/TOGGLE_NOTIFICATION_MODAL';
export const SET_FERTILIZATION_PARAMS = 'geoface/SET_FERTILIZATION_PARAMS';
export const SET_HEADER_SELECTOR_DISABILITY = 'geoface/SET_HEADER_SELECTOR_DISABILITY';
export const TOGGLE_SHOW_MOBILE_MAP = 'geoface/TOGGLE_SHOW_MOBILE_MAP';
export const TOGGLE_SHOW_FIELD_LIST = 'geoface/TOGGLE_SHOW_FIELD_LIST';
export const TOGGLE_MOBILE_MODAL_SELECT = 'geoface/TOGGLE_MOBILE_MODAL_SELECT';
export const SET_DISABLE_COMPANY_SELECT = 'geoface/SET_DISABLE_COMPANY_SELECT';

export const FIELDS_LOADING = 'geoface/FIELDS_LOADING';

export const SAVE_MAP_ANALYSIS = 'geoface/SAVE_MAP_ANALYSIS';
export const CLEAR_MAP_ANALYSIS = 'geoface/CLEAR_MAP_ANALYSIS';

export const LOAD_DATE = 'geoface/LOAD_DATE';
export const SET_NDVI_BOUNDS = 'geoface/SET_NDVI_BOUNDS';
export const SET_GROUP_STATE = 'geoface/SET_GROUP_STATE';
export const SET_GROUP_SELECTED_FIELDS = 'geoface/SET_GROUP_SELECTED_FIELDS';
export const SET_SCOUTING_LAT_LNG = 'geoface/fields/SET_SCOUTING_LAT_LNG';
export const SET_INFOPANEL_ISOPEN = 'geoface/fields/SET_INFOPANEL_ISOPEN';
export const SET_TASK_DATA = 'geoface/fields/SET_TASK_DATA';

export const SET_EDITING_CLOSE_POPUP = 'geoface/SET_EDITING_CLOSE_POPUP';
export const SET_CLOSE_POPUP_MODAL_OPEN = 'geoface/SET_CLOSE_POPUP_MODAL_OPEN';
export const SET_SPLITTING_FIELD = 'geoface/SET_SPLITTING_FIELD';

export const SET_FIELDS_FILTER_OPENED = 'geoface/SET_FILTER_OPENED';
export const SET_VISIBLE_FIELDS = 'geoface/SET_VISIBLE_FIELDS';

export const SET_SHOW_POLYGON_LABEL = 'geoface/SET_SHOW_POLYGON_LABEL';
export const SET_POLYGON_LABEL_KEY = 'geoface/SET_POLYGON_LABEL_KEY';

export const SET_VRA_NDVI_OVERLAYS = 'geoface/SET_VRA_NDVI_OVERLAYS';
export const SET_VRA_NDVI_LOADING = 'geoface/SET_VRA_NDVI_LOADING';
export const SET_VRA_MAP_LAYERS = 'geoface/SET_VRA_MAP_LAYERS';
export const SET_VRA_ANALYSIS_OVERLAYS = 'geoface/SET_VRA_ANALYSIS_OVERLAYS';
export const SET_LAYER_OPACITY = 'geoface/SET_LAYER_OPACITY';
